/* eslint-disable formatjs/no-literal-string-in-jsx */
import { CfLoader } from "../../../shared/components/common/CfLoader/CfLoader";

type Props = {
  error: Error;
};

const ChunkErrorFallback = ({ error }: Props) => {
  // we don't want refresh to happen on localhost
  const isLocalhost = window.location.hostname === "localhost";
  const isChunkLoadError =
    /Loading chunk [\d]+ failed|ChunkLoadError|dynamic import|dynamic|module|chunk/i.test(
      error.message,
    );

  if (isChunkLoadError && !isLocalhost) {
    // eslint-disable-next-line no-console
    console.warn(
      "[ChunkErrorFallback] Chunk load failed. Forcing hard reload.",
    );
    setTimeout(() => {
      window.location.reload();
    }, 100);
    return <div>Updating app... Please wait.</div>;
  }

  return (
    <div>
      <CfLoader />
    </div>
  );
};

export { ChunkErrorFallback };
